import React from "react";
import AboutUsMisyon from "../AboutUsMisyon/AboutUsMisyon";
import AboutUsVizyon from "../AboutUsVizyon/AboutUsVizyon";
import AboutUsHikayem from "../AboutUsHikayem/AboutUsHikayem";
import AboutUsDegerler from "../AboutUsDegerler/AboutUsDegerler";
import AboutUsKurumsalKimlik from "../AboutUsKurumsalKimlik/AboutUsKurumsalKimlik";
import AboutUsIletisim from "../AboutUsIletisim/AboutUsIletisim";

const AboutUsPage = () => {
  return (
    <div className="contact-page">
      <AboutUsMisyon />
      <AboutUsVizyon />
      <AboutUsHikayem />
      <AboutUsDegerler/>
      <hr />
      <AboutUsKurumsalKimlik />
      <AboutUsIletisim />
    </div>
  );
};

export default AboutUsPage;
